import React from "react";
import styled from "styled-components";

const Text = styled.h1`
  font-size: 19px;
  &:not(:last-child) {
    margin-bottom: 50px;
  }
  &:last-child {
    margin-bottom: 150px;
  }
  line-height: 30px;
`;

const Content = ({ children }) => <Text>{children}</Text>;

export default Content;
